module.exports = __webpack_public_path__ + "img/f_c_sc_3.b1962e90.png";